import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_a_system_for_reviewing_policies_and_procedure'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_a_system_for_reviewing_policies_and_procedure',
  name: 'Does the facility have a system for reviewing policies and procedures (written or informal) for changes/updates to existing requirements (legal or other)?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'GOVERNMENT_WEBSITES',
      text: 'Government websites',
      externalIds: [
        {
          id: 'ms-6--1-1x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'GOVERNMENT_OFFICES_COMMUNICATIONS',
      text: 'Government offices /communications',
      externalIds: [
        {
          id: 'ms-6--1-2x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CONSULTANTS',
      text: 'Consultants',
      externalIds: [
        {
          id: 'ms-6--1-3x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'INTERNET',
      text: 'Internet',
      externalIds: [
        {
          id: 'ms-6--1-4x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CUSTOMER_BRIEFING',
      text: 'Customer briefing',
      externalIds: [
        {
          id: 'ms-6--1-5x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HEALTH_AND_SAFETY_EXECUTIVE',
      text: 'Health and safety executive',
      externalIds: [
        {
          id: 'ms-6--1-6x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CORPORATE_SOCIAL_RESPONSIBILITY_OR_CSR_TEAM_ESTABLISHED_IN_FACI',
      text: 'Corporate Social Responsibility or "CSR" team established in facility',
      externalIds: [
        {
          id: 'ms-6--1-7x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MANAGEMENT_TEAM_BRIEFS_THE_WORKFORCE',
      text: 'Management team briefs the workforce',
      externalIds: [
        {
          id: 'ms-6--1-8x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'APPOINTED_WORKER_TEAM',
      text: 'Appointed worker / team',
      externalIds: [
        {
          id: 'ms-6--1-9x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MAGAZINE_SUBSCRIPTION_S_',
      text: 'Magazine subscription(s)',
      externalIds: [
        {
          id: 'ms-6--1-10x',
          version: 1.3,
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'INDUSTRY_BODY_BRIEFINGS',
      text: 'Industry body briefings',
      externalIds: [
        {
          id: 'ms-6--1-11x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-6--1-12x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-6--1-12f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'GOVERNMENT_WEBSITES',
                'GOVERNMENT_OFFICES_COMMUNICATIONS',
                'CONSULTANTS',
                'INTERNET',
                'CUSTOMER_BRIEFING',
                'HEALTH_AND_SAFETY_EXECUTIVE',
                'CORPORATE_SOCIAL_RESPONSIBILITY_OR_CSR_TEAM_ESTABLISHED_IN_FACI',
                'MANAGEMENT_TEAM_BRIEFS_THE_WORKFORCE',
                'APPOINTED_WORKER_TEAM',
                'MAGAZINE_SUBSCRIPTION_S_',
                'INDUSTRY_BODY_BRIEFINGS',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-che-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 23200,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
